export default __webpack_public_path__ + "static/media/08b57253-2e0d-4c12-9c57-107f6c67bc49.2d8377e1.woff2";